import {GenSystemEventAnalytic} from '../../../../../generated/serverModels/GenSystemEventAnalytic';
import {GenSystemEventAnalyticStatus} from '../../../../../generated/serverModels/GenSystemEventAnalyticStatus';

export class SystemEventAnalytic extends GenSystemEventAnalytic {
    public status: GenSystemEventAnalyticStatus;

    constructor(analytic?: SystemEventAnalytic) {
        super(analytic);

        if (analytic) {
            if (this.history && this.history.length > 0) {
                this.status = this.history.sort((a, b) => {
                    if (b.updateTime.isAfter(a.updateTime)) return 1;
                    else if (b.updateTime.isBefore(a.updateTime)) return -1;
                    return 0;
                })[0].status;
            }
        }
    }
}
